<div class="limit-status-modal-overlay" *ngIf="modalState.visible">
  <div class="limit-status-modal-card">
    <div class="limit-status-modal-header">
      <h3>{{ modalState.title }}</h3>
      <button
        *ngIf="canCloseModal()"
        type="button"
        class="limit-modal-close"
        (click)="close()"
      >
        X
      </button>
    </div>

    <p class="limit-status-description">{{ modalState.description }}</p>

    <div class="limit-status-tag" [ngClass]="getStatusClass(modalState.status)">
      Status: {{ getLimitStatusDisplay(modalState.status) }}
    </div>

    <div class="limit-doc-form" *ngIf="modalState.requiresDocuments">
      <h4>Reenvio de documentos</h4>
      <p>Escolha como deseja capturar os documentos para reenviar sua analise.</p>

      <div class="capture-options">
        <button
          type="button"
          class="capture-option"
          [class.active]="documentSource === 'CAMERA'"
          (click)="selectDocumentSource('CAMERA')"
        >
          <span class="capture-icon">📷</span>
          Tirar foto
        </button>

        <button
          type="button"
          class="capture-option"
          [class.active]="documentSource === 'UPLOAD'"
          (click)="selectDocumentSource('UPLOAD')"
        >
          <span class="capture-icon">📁</span>
          Enviar fotos
        </button>
      </div>

      <div class="capture-helper" *ngIf="!documentSource">
        Selecione uma opcao para abrir os campos de envio.
      </div>

      <div *ngIf="documentSource === 'CAMERA'" class="camera-capture-panel">
        <p class="capture-helper">Posicione o documento no quadro e capture frente e verso.</p>

        <div class="camera-preview-wrapper">
          <video #limitCameraVideo autoplay playsinline muted></video>
          <canvas #limitCameraCanvas class="camera-canvas-hidden"></canvas>
        </div>

        <div class="camera-capture-actions">
          <button type="button" class="camera-capture-btn" (click)="captureFromCamera('front')">
            Capturar frente
          </button>
          <button type="button" class="camera-capture-btn" (click)="captureFromCamera('back')">
            Capturar verso
          </button>
        </div>

        <div class="camera-captured-grid">
          <div class="camera-captured-item" [class.done]="documentFrontFile">
            <p>Frente</p>
            <img *ngIf="frontPreviewUrl" [src]="frontPreviewUrl" alt="Frente capturada" />
            <small>{{ documentFrontFile?.name || 'Ainda nao capturado' }}</small>
          </div>

          <div class="camera-captured-item" [class.done]="documentBackFile">
            <p>Verso</p>
            <img *ngIf="backPreviewUrl" [src]="backPreviewUrl" alt="Verso capturado" />
            <small>{{ documentBackFile?.name || 'Ainda nao capturado' }}</small>
          </div>
        </div>
      </div>

      <div *ngIf="documentSource === 'UPLOAD'">
        <p class="capture-helper">Selecione as imagens ja salvas no seu dispositivo.</p>

        <label class="doc-input-group" [class.has-file]="documentFrontFile">
          <span>Frente do documento</span>
          <input class="doc-input-native" type="file" accept="image/*" (change)="onDocumentFileSelected($event, 'front')" />
          <span class="doc-input-surface">
            <span class="doc-input-copy">
              <strong>{{ documentFrontFile ? 'Arquivo selecionado' : 'Selecionar imagem da frente' }}</strong>
              <small>{{ documentFrontFile?.name || 'JPG, PNG ou WEBP ate 10MB' }}</small>
            </span>
            <span class="doc-input-action">Escolher arquivo</span>
          </span>
        </label>

        <label class="doc-input-group" [class.has-file]="documentBackFile">
          <span>Verso do documento</span>
          <input class="doc-input-native" type="file" accept="image/*" (change)="onDocumentFileSelected($event, 'back')" />
          <span class="doc-input-surface">
            <span class="doc-input-copy">
              <strong>{{ documentBackFile ? 'Arquivo selecionado' : 'Selecionar imagem do verso' }}</strong>
              <small>{{ documentBackFile?.name || 'JPG, PNG ou WEBP ate 10MB' }}</small>
            </span>
            <span class="doc-input-action">Escolher arquivo</span>
          </span>
        </label>
      </div>

      <div class="limit-doc-feedback error" *ngIf="documentSubmitError">
        {{ documentSubmitError }}
      </div>

      <div class="limit-doc-feedback success" *ngIf="documentSubmitSuccess">
        {{ documentSubmitSuccess }}
      </div>

      <button
        type="button"
        class="limit-doc-submit"
        (click)="submitLimitDocuments()"
        [disabled]="isSubmittingDocuments"
      >
        {{ isSubmittingDocuments ? 'Enviando documentos...' : 'Enviar documentos' }}
      </button>
    </div>
  </div>
</div>
